import { LoadingProps } from "./Loading.types";

/** A centred spinner, announced to screen readers as loading. */
export function Loading({ className = "spinner-border m-3" }: LoadingProps) {
  return (
    <div className="d-flex align-items-center justify-content-center">
      <div className={className} role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}

export default Loading;
